import React, { useState, useEffect } from "react";
import {
  getDealerWarrantyList,
  updateDealerWarranty,
} from "../../../services/apiService";

const PendingWarrantyList = () => {
  const [search, setSearch] = useState("");
  const [pendingWarrantyData, setPendingWarrantyData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedWarranty, setSelectedWarranty] = useState(null);
  const [showRejectBox, setShowRejectBox] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  useEffect(() => {
    fetchWarrantyList();
  }, []);

  const fetchWarrantyList = async () => {
    try {
      setLoading(true);
      const response = await getDealerWarrantyList();
      console.log("API Response:", response);
      const data = response?.data || response?.Data || response || [];
      const pendingData = data.filter(
        (item) => item.isapproved === "0"
      );
      console.log("Pending Data:", pendingData);
      setPendingWarrantyData(pendingData);
      setCurrentPage(1); // Reset to first page on data fetch
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const filtered = pendingWarrantyData.filter(
    (item) =>
      item.orderno?.toLowerCase().includes(search.toLowerCase()) ||
      item.modelno?.toLowerCase().includes(search.toLowerCase()) ||
      item.scratchno?.toLowerCase().includes(search.toLowerCase())
  );

  // Calculate total pages
  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  // Get current page data
  const paginatedData = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleApproveWarranty = async () => {
    const payload = {
      id: selectedWarranty.id,
      userid: selectedWarranty.userid,
      orderno: selectedWarranty.orderno,
      category: selectedWarranty.category,
      modelno: selectedWarranty.modelno,
      invoiceimage: selectedWarranty.invoiceimage,
      productimage: selectedWarranty.productimage,
      warrantydays: selectedWarranty.warrantydays,
      startdate: selectedWarranty.startdate,
      enddate: selectedWarranty.enddate,
      warrantycard: selectedWarranty.warrantycard,
      sku: selectedWarranty.sku,
      dealername: selectedWarranty.dealername,
      dealerstate: selectedWarranty.dealerstate,
      dealercity: selectedWarranty.dealercity,
      scratchno: selectedWarranty.scratchno,
      productid: selectedWarranty.productid,
      clientid: selectedWarranty.clientid,
      active: selectedWarranty.active,
      isapproved: "1",
      hologramno: selectedWarranty.hologramno,
      discription: "",
      image1: selectedWarranty.image1,
    };

    try {
      await updateDealerWarranty(payload);

      alert("Warranty approved successfully.");
      setShowModal(false);
      setSelectedWarranty(null);
      setShowRejectBox(false);
      setRejectReason("");
      fetchWarrantyList();
    } catch (error) {
      console.error("Approve Warranty Error:", error);
      alert("Failed to approve warranty.");
    }
  };

  const handleRejectWarranty = async () => {
    if (!rejectReason.trim()) {
      alert("Please enter the rejection reason.");
      return;
    }

    const payload = {
      id: selectedWarranty.id,
      userid: selectedWarranty.userid,
      orderno: selectedWarranty.orderno,
      category: selectedWarranty.category,
      modelno: selectedWarranty.modelno,
      invoiceimage: selectedWarranty.invoiceimage,
      productimage: selectedWarranty.productimage,
      warrantydays: selectedWarranty.warrantydays,
      startdate: selectedWarranty.startdate,
      enddate: selectedWarranty.enddate,
      warrantycard: selectedWarranty.warrantycard,
      sku: selectedWarranty.sku,
      dealername: selectedWarranty.dealername,
      dealerstate: selectedWarranty.dealerstate,
      dealercity: selectedWarranty.dealercity,
      scratchno: selectedWarranty.scratchno,
      productid: selectedWarranty.productid,
      clientid: selectedWarranty.clientid,
      active: selectedWarranty.active,
      isapproved: "2",
      hologramno: selectedWarranty.hologramno,
      discription: rejectReason,
      image1: selectedWarranty.image1,
    };

    try {
      await updateDealerWarranty(payload);
      alert("Warranty rejected successfully.");
      setShowRejectBox(false);
      setRejectReason("");
      setShowModal(false);
      setSelectedWarranty(null);
      fetchWarrantyList();
    } catch (error) {
      console.error("Reject Warranty Error:", error);
      alert("Failed to reject warranty.");
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ marginBottom: "15px" }}>Pending Warranty List</h2>

      <input
        type="text"
        placeholder="Search Warranty ID, Customer, Product..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setCurrentPage(1); // Reset to first page on search
        }}
        style={{
          width: "320px",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          marginBottom: "20px",
        }}
      />

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "14px",
        }}
      >
        {loading && <p>Loading...</p>}
        <thead>
          <tr style={{ backgroundColor: "#d3d7dc" }}>
            <th style={th}>s.no</th>
            <th style={th}>Invoice No</th>
            <th style={th}>Customer</th>
            <th style={th}>Dealer id</th>
            <th style={th}>Product</th>
            <th style={th}>Stratch No</th>
            <th style={th}>Hologram No</th>
            <th style={th}>Purchase Date</th>
            <th style={th}>Status</th>
            <th style={th}>Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((row, index) => (
              <tr key={row.id || row.warrantyId}>
                <td style={td}>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td style={td}>{row.orderno}</td>
                <td style={td}>{row.first_name}</td>
                <td style={td}>{row.dealername}</td>
                <td style={td}>{row.modelno}</td>
                <td style={td}>{row.scratchno}</td>
                <td style={td}>{row.hologramno}</td>
                <td style={td}>{new Date(row.startdate).toLocaleDateString("en-GB")}</td>
                <td style={td}>
                  <span
                    style={{
                      backgroundColor: row.active === "0" ? "#ffc107" : "#28a745",
                      color: "#000",
                      padding: "5px 12px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    {row.active === "0" ? "Pending" : "Approved"}
                  </span>
                </td>
                <td style={td}>
                  <button
                    style={{
                      backgroundColor: "#005487",
                      color: "#fff",
                      border: "none",
                      padding: "8px 18px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSelectedWarranty(row);
                      setShowModal(true);
                    }}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td style={td} colSpan="10">
                No records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div
        style={{
          marginTop: "25px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <strong>Items per page:</strong>
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value));
              setCurrentPage(1);
            }}
            style={{
              marginLeft: "10px",
              padding: "5px",
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
          </select>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{
              padding: "6px 12px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
            }}
          >
            Previous
          </button>
          <strong>
            {currentPage} / {totalPages}
          </strong>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              padding: "6px 12px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
            }}
          >
            Next
          </button>
        </div>
      </div>

      {/* Modal for warranty details, approve/reject buttons, and rejection reason */}
      {showModal && selectedWarranty && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "600px",
              borderRadius: "8px",
              padding: "25px",
              position: "relative",
            }}
          >
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: 10,
                right: 15,
                border: "none",
                background: "transparent",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              ×
            </button>
            <h3 style={{ marginBottom: "20px" }}>Warranty Details</h3>
            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <img
                  src={selectedWarranty.image1}
                  alt="Product"
                  style={{
                    width: "160px",
                    height: "120px",
                    objectFit: "contain",
                    border: "1px solid #ddd",
                    padding: "10px",
                  }}
                />
                <img
                  src={selectedWarranty.invoiceimage}
                  alt="Invoice"
                  style={{
                    width: "160px",
                    height: "120px",
                    objectFit: "contain",
                    border: "1px solid #ddd",
                    padding: "10px",
                  }}
                />
                {/* Removed duplicate invoice image */}
              </div>
              <div style={{ flex: 1 }}>
                <p>
                  <strong>ID:</strong> {selectedWarranty.id}
                </p>
                <p>
                  <strong>Product ID:</strong> {selectedWarranty.productid}
                </p>
                <p>
                  <strong>Model No:</strong> {selectedWarranty.modelno}
                </p>
                <p>
                  <strong>Category:</strong> {selectedWarranty.category}
                </p>
                <p>
                  <strong>Hologram No:</strong> {selectedWarranty.hologramno}
                </p>
                <p>
                  <strong>Warranty:</strong>{" "}
                  {selectedWarranty.warrantydays || "N/A"} Days
                </p>
                <p>
                  <strong>Start Date:</strong>{" "}
                  {new Date(selectedWarranty.startdate).toLocaleDateString(
                    "en-GB"
                  )}
                </p>
                <p>
                  <strong>End Date:</strong>{" "}
                  {new Date(selectedWarranty.enddate).toLocaleDateString(
                    "en-GB"
                  )}
                </p>
                {!showRejectBox ? (
                  <>
                    <button
                      onClick={handleApproveWarranty}
                      style={{
                        backgroundColor: "#005487",
                        color: "#fff",
                        border: "none",
                        padding: "8px 18px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => setShowRejectBox(true)}
                      style={{
                        backgroundColor: "#ce2424",
                        marginLeft: "20px",
                        color: "#fff",
                        border: "none",
                        padding: "8px 18px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Reject
                    </button>
                  </>
                ) : (
                  <div style={{ marginTop: "20px" }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "8px",
                        fontWeight: "600",
                      }}
                    >
                      Reason for Rejection <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      rows={4}
                      value={rejectReason}
                      onChange={(e) => setRejectReason(e.target.value)}
                      placeholder="Enter rejection reason..."
                      style={{
                        width: "100%",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                      }}
                    />
                    <div
                      style={{
                        marginTop: "15px",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                      }}
                    >
                      <button
                        onClick={() => {
                          setShowRejectBox(false);
                          setRejectReason("");
                        }}
                        style={{
                          background: "#6c757d",
                          color: "#fff",
                          border: "none",
                          padding: "8px 18px",
                          borderRadius: "5px",
                          cursor: "pointer",
                        }}
                      >
                        Back
                      </button>
                      <button
                        disabled={!rejectReason.trim()}
                        style={{
                          backgroundColor: rejectReason.trim()
                            ? "#ce2424"
                            : "#ccc",
                          color: "#fff",
                          border: "none",
                          padding: "8px 18px",
                          borderRadius: "5px",
                          cursor: rejectReason.trim()
                            ? "pointer"
                            : "not-allowed",
                        }}
                        onClick={handleRejectWarranty}
                      >
                        Submit Reject
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const th = {
  border: "1px solid #ddd",
  padding: "10px",
  textAlign: "left",
  fontWeight: "bold",
};

const td = {
  border: "1px solid #ddd",
  padding: "10px",
};

export default PendingWarrantyList;         